import { useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import home from '../../assets/images/home.png'

const Header = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { i18n } = useTranslation()

  const currentLanguage = (i18n.language || 'english').toLowerCase().startsWith('français') ? 'français' : 'english'
  const nextLanguage = currentLanguage === 'english' ? 'français' : 'english'
  const isGamePage = location.pathname === '/game'
  const isHomePage = location.pathname === '/'
  const toggleLabel = nextLanguage.charAt(0).toUpperCase() + nextLanguage.slice(1)
  const showLanguageToggle = !isGamePage
  const showHomeIcon = !isHomePage

  const handleToggleLanguage = () => {
    i18n.changeLanguage(nextLanguage)
    try {
      window.localStorage.setItem('language', nextLanguage)
      window.localStorage.setItem('lang', nextLanguage)
    } catch {}
  }

  return (
    <header className="w-full">
      <div className="w-full h-[577px] flex justify-center items-center">
      </div>

      <div
        className={`w-full absolute h-[80px] right-0 -mt-[490px] px-[95px] flex items-center ${
          showLanguageToggle && showHomeIcon
            ? 'justify-between'
            : showLanguageToggle
              ? 'justify-start'
              : 'justify-end'
        }`}
      >
        {showLanguageToggle && (
          <button
            type="button"
            className="text-white text-[18px] mt-[620px] z-[100] border border-white/70 rounded-lg px-11 py-3 leading-none cursor-pointer active:bg-white/10"
            aria-label={`Switch language to ${toggleLabel}`}
            onClick={handleToggleLanguage}
          >
            {toggleLabel}
          </button>
        )}

        {showHomeIcon && (
          <img src={home} alt="home" className="cursor-pointer" onClick={() => navigate('/')} />
        )}
      </div>
    </header>
  )
}

export default Header
